import React from "react";
import {
  HomeOutlined,
  SettingOutlined,
  CalendarOutlined,
  HistoryOutlined,
  UserOutlined,
  BuildOutlined,
} from "@ant-design/icons";

import DashboardLayout from "./layouts/dashboard";
import Login from "./pages/login";
import RegisterPage from "./pages/register";
import NotFoundPage from "./pages/404Page";

const HomePageComponent = React.lazy(() =>
  import("./pages/homePage")
);
const SettingsPageComponent = React.lazy(() =>
  import("./pages/settings")
);
const CompanyOverviewPageComponent = React.lazy(() =>
  import("./pages/company")
);
const UsersPageComponent = React.lazy(() =>
  import("./pages/userManagement")
);
const UsageHistoryPageComponent = React.lazy(() =>
  import("./pages/usageHistory")
);

export const INDEX_ROUTE = "/";
export const SETTINGS_ROUTE = "/settings";
export const COMPANY_OVERVIEW_ROUTE = "/my-company";
export const USERS_ROUTE = "/users";
export const USAGE_HISTORY_ROUTE = "/usage-history";
// ROUTES
export const NON_LOGIN_ROUTES = [
  {
    exact: true,
    name: "login",
    path: INDEX_ROUTE,
    component: Login,
  },
  {
    component: NotFoundPage,
  },
];

export const LOGGED_IN_ROUTES = [
  {
    name: "layout",
    path: INDEX_ROUTE,
    component: DashboardLayout,
    routes: [
      {
        exact: true,
        name: "home",
        path: INDEX_ROUTE,
        component: HomePageComponent,
      },
      // {
      //   exact: true,
      //   name: "settings",
      //   path: SETTINGS_ROUTE,
      //   component: SettingsPageComponent,
      // },
      {
        exact: true,
        name: "my-company",
        path: COMPANY_OVERVIEW_ROUTE,
        component: CompanyOverviewPageComponent,
      },
      {
        exact: true,
        name: "users",
        path: USERS_ROUTE,
        component: UsersPageComponent,
      },
      {
        exact: true,
        name: "usage-history",
        path: USAGE_HISTORY_ROUTE,
        component: UsageHistoryPageComponent,
      },
    ],
  },
  {
    component: NotFoundPage,
  },
];


export const SIDEBAR_ITEMS = [
  {
    name: "home",
    label: "Dashboard",
    route: INDEX_ROUTE,
    icon: <HomeOutlined />,
  },
  {
    name: "usage-history",
    label: "Usage History",
    route: USAGE_HISTORY_ROUTE,
    icon: <HistoryOutlined />,
  },
  {
    name: "/company",
    label: "Company",
    icon: <SettingOutlined />,
    submenu: [
      {
        name: "users",
        label: "Users",
        route: USERS_ROUTE,
        icon: <UserOutlined />,
      },
      {
        name: "my-company",
        label: "Company Overview",
        route: COMPANY_OVERVIEW_ROUTE,
        icon: <BuildOutlined />,
      },
    ]
  },
  // {
  //   name: "/settings",
  //   label: "Settings",
  //   icon: <SettingOutlined />,
  //   submenu: [
  //     {
  //       name: "account-settings",
  //       label: "My Account",
  //       route: SETTINGS_ROUTE,
  //       icon: <SettingOutlined />,
  //     },
  //   ]
  // },
];
